/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_JoinInputs */

const en_footer_join = /** @type {(inputs: Footer_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join PauseAI >`)
};

/**
* | output |
* | --- |
* | "Join PauseAI >" |
*
* @param {Footer_JoinInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer_join = /** @type {((inputs?: Footer_JoinInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_JoinInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer_join(inputs)
});